import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Card, Form, Row, Input, Select, Col, Button, Typography, Modal, message, Spin, InputNumber } from "antd";
import { IuserProfile, typeTeam } from "../../models/models-datamanagement";
import { DatamanagementService } from "../../services/datamanagement-service";
import { ExclamationCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { loadAppConfig } from "../../../../config/app-config";
import { useId24 } from "../../../../drivers/id24/Id24-provider";
import { BuddhistRangePickerDisabled } from "../../../../utils/buddhist-data";
import TextArea from "antd/lib/input/TextArea";
import dayjs, { Dayjs } from "dayjs";
import { DateStamp } from "../../../../utils/time-convertor";
import { checknumberformat, checknumberformatnodecimal } from "../../../../utils/helper-form";
const appConfig = loadAppConfig();
interface Props {
  baseUrl: string;
  accessRole: any;
}
export const AddConditionRuleDetail: React.FC<Props> = ({ baseUrl, accessRole }): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrlCore = id24Axios(appConfig.apiBaseUrl);
  const apiBaseUrlDebt = id24Axios(appConfig.apiBaseUrlDebt);
  const location: any = useLocation();
  const data = location.state;

  const { push } = useHistory();
  const [getdataWorkList, setdataWorkList] = useState<string[]>([]);
  const [getdataFloodStatus, setdataFloodStatus] = useState<string[]>([]);
  const [getdataRiskScore, setdataRiskScore] = useState<string[]>([]);
  const [getdataBillCode, setdataBillCode] = useState<string[]>([]);
  const [getdataCustType, setdataCustType] = useState<string[]>([]);
  const [getdataLastTermCode, setdataLastTermCode] = useState<string[]>([]);
  const [getTeam, setTeam] = useState<typeTeam[]>([]);
  const [userProfile, setUserprofile] = useState<IuserProfile>({
    id: 0,
    level: "",
    name: "",
    oaCode: "",
    parentId: "",
    team: "",
    token: "",
    type: "",
    capabilities: {},
  });

  const [getloading, setLoading] = useState<boolean>(true);
  const [form] = Form.useForm();

  let date = dayjs.unix(data?.fields?.dtlLastPay?.value);
  let datatime: string | Dayjs = "";
  if (data?.fields?.dtlLastPay?.op === ">") {
    datatime = dayjs(date).subtract(data?.number_dtlLastPay, "day");
  } else {
    datatime = dayjs(date).add(data?.number_dtlLastPay, "day");
  }

  useEffect(() => {
    const loaddatauser = async () => {
      const resualProfile: IuserProfile = await DatamanagementService(apiBaseUrlDebt).getUserDetail();
      const resual = await DatamanagementService(apiBaseUrlDebt).getTeamByUser(resualProfile.id);
      setTeam(resual);
      setUserprofile(resualProfile);
    };
    const loaddatadropdown = async () => {
      const resultWorklist: string[] = await DatamanagementService(apiBaseUrlDebt).getdataworklist();
      const resultFloodStatus: string[] = await DatamanagementService(apiBaseUrlDebt).getdatafloodstatus();
      const resultRiskScore: string[] = await DatamanagementService(apiBaseUrlDebt).getdatariskscore();
      const resultBillCode: string[] = await DatamanagementService(apiBaseUrlDebt).getdatabillcode();
      const resultCustType: string[] = await DatamanagementService(apiBaseUrlDebt).getdatacusttype();
      const resultLastTermCode: string[] = await DatamanagementService(apiBaseUrlDebt).getdatalasttermcode();
      setdataWorkList(resultWorklist);
      setdataFloodStatus(resultFloodStatus);
      setdataRiskScore(resultRiskScore);
      setdataBillCode(resultBillCode);
      setdataCustType(resultCustType);
      setdataLastTermCode(resultLastTermCode);
      setLoading(false);
    };
    loaddatadropdown();
    loaddatauser();
  }, [getloading, data]);

  const onClickUpdate = async (status: any) => {
    if (status.buttonSubmit === "DISABLED") {
      Modal.confirm({
        title: "คุณแน่ใจแล้วใช่ไหม",
        icon: <ExclamationCircleOutlined />,
        content: "กดยืนยันเพื่อบันทึกข้อมูล",
        okText: "ยืนยัน",
        cancelText: "ยกเลิก",
        onOk: async () => {
          const resual = await DatamanagementService(apiBaseUrlCore).updateConditionByseq(data?.seq, userProfile, status?.buttonSubmit);
          if (resual) {
            message.success("Success");
            push(`/datamanagement`);
          }
        },
        onCancel: () => {},
      });
    }
  };

  return getloading ? (
    <div style={{ height: "700px", justifyContent: "center", display: "flex", alignItems: "center" }}>
      <Spin />
    </div>
  ) : (
    <Row
      gutter={[
        { xs: 8, sm: 16 },
        { xs: 8, sm: 16 },
      ]}
      style={{ marginTop: "2rem" }}
    >
      <Card style={{ width: "100%", textAlign: "left" }} title="Condition List">
        <Form
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          name="view_condition"
          fields={[
            { name: "condition_name", value: data.listname },
            { name: "description", value: data.description },
            { name: "team", value: data.distribution },
            { name: "riskScore", value: data.fields?.riskScore?.value },
            { name: "workList", value: data.fields?.workList?.value },
            { name: "floodStatus", value: data.fields?.floodStatus?.value },
            { name: "billCode", value: data.fields?.billCode?.value },
            { name: "dates", value: data.fields?.dtlLastPay?.value ? datatime : null },
            { name: "condition_dtlLastPay", value: data.fields?.dtlLastPay?.op },
            { name: "conditon_osBal", value: data.fields?.osBal?.op == "between" ? "Between" : data.fields?.osBal?.op },
            {
              name: "osBal_one",
              value: data?.fields?.osBal?.value?.length > 1 ? checknumberformat(data?.fields?.osBal?.value[0]) : null,
            },
            {
              name: "osBal_two",
              value: data?.fields?.osBal?.value?.length > 1 ? checknumberformat(data?.fields?.osBal?.value[1]) : null,
            },
            { name: "osBal", value: data.fields?.osBal?.value ? checknumberformat(data.fields?.osBal?.value) : null },
            { name: "custType", value: data.fields?.custType?.value },
            { name: "lastTermCode", value: data.fields?.lastTermCode?.value },
            { name: "number_dtlLastPay", value: data?.number_dtlLastPay ? checknumberformatnodecimal(Number(data?.number_dtlLastPay)) : null },
          ]}
          onFinish={onClickUpdate}
        >
          <Row gutter={[8, 8]}>
            <Col span={24}>
              <Form.Item label="Condition List Name :" name={`condition_name`} style={{ paddingRight: "100px" }}>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Description :" name={`description`} style={{ paddingRight: "100px" }}>
                <TextArea rows={4} showCount maxLength={250} disabled />
              </Form.Item>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography style={{ fontWeight: "bold" }}>{`No.`}</Typography>
            </Col>
            <Col span={12}>
              <Typography style={{ fontWeight: "bold" }}>{`Field`}</Typography>
            </Col>
            <Col span={10}>
              <Typography style={{ fontWeight: "bold" }}>{`Value`}</Typography>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`1.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`Worklist`} style={{ color: "grey" }} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`workList`}>
                <Select
                  disabled
                  mode="multiple"
                  style={{ width: "100%" }}
                  options={getdataWorkList?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`2.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`สีน้ำท่วม`} style={{ color: "grey" }} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`floodStatus`}>
                <Select
                  disabled
                  style={{ width: "100%" }}
                  mode="multiple"
                  // placeholder={`Please Select`}
                  options={getdataFloodStatus?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`3.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`Bscore`} style={{ color: "grey" }} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`riskScore`}>
                <Select
                  disabled
                  style={{ width: "100%" }}
                  mode="multiple"
                  // placeholder={`Please Select`}
                  options={getdataRiskScore?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>

            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`4.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`Billcode`} style={{ color: "grey" }} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`billCode`}>
                <Select
                  disabled
                  style={{ width: "100%" }}
                  mode="multiple"
                  // placeholder={`Please Select`}
                  options={getdataBillCode?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>

            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`5.`}</Typography>
            </Col>
            <Col span={6}>
              <Input value={`สัญญาที่มีการจ่ายภายใน`} style={{ color: "grey" }} readOnly />
            </Col>
            <Col span={6}>
              <Form.Item name={`condition_dtlLastPay`}>
                <Select disabled allowClear style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Row gutter={[8, 8]}>
                <Col span={10}>
                  <Form.Item name={`number_dtlLastPay`}>
                    <Input disabled allowClear style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <BuddhistRangePickerDisabled />
                </Col>
              </Row>
            </Col>

            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`6.`}</Typography>
            </Col>
            <Col span={12}>
              <Row gutter={[8, 8]}>
                <Col span={12}>
                  <Input value={`OS`} style={{ color: "grey", width: "100%" }} readOnly />
                </Col>
                <Col span={12}>
                  <Form.Item name={`conditon_osBal`}>
                    <Select disabled allowClear style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            {data.fields?.osBal?.op === "between" ? (
              <>
                <Col span={4}>
                  <Form.Item name={`osBal_one`}>
                    {/* <Input disabled /> */}
                    <Input style={{ width: "100%" }} disabled />
                  </Form.Item>
                </Col>
                <Col span={1}>
                  <Typography.Text>{`ถึง`}</Typography.Text>
                </Col>
                <Col span={4}>
                  <Form.Item name={`osBal_two`}>
                    {/* <Input disabled /> */}
                    <Input style={{ width: "100%" }} disabled />
                  </Form.Item>
                </Col>
              </>
            ) : (
              <Col span={10}>
                <Form.Item name={`osBal`}>
                  {/* <Input disabled /> */}
                  <Input style={{ width: "100%" }} disabled />
                </Form.Item>
              </Col>
            )}
            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`7.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`ประเภทลูกค้า`} style={{ color: "grey", width: "100%" }} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`custType`}>
                <Select
                  disabled
                  style={{ width: "100%" }}
                  mode="multiple"
                  options={getdataCustType?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>

            <Col span={2} style={{ justifyContent: "center", display: "flex" }}>
              <Typography>{`8.`}</Typography>
            </Col>
            <Col span={12}>
              <Input value={`Last Result`} style={{ color: "grey" }} readOnly />
            </Col>
            <Col span={10}>
              <Form.Item name={`lastTermCode`}>
                <Select
                  disabled
                  style={{ width: "100%" }}
                  // placeholder={`Please Select`}
                  mode="multiple"
                  options={getdataLastTermCode?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                />
              </Form.Item>
            </Col>

            <Form.Item name="buttonSubmit" style={{ display: "none" }}>
              <Input type="hidden" />
            </Form.Item>
            <Col span={24}>
              <Form.Item label={`Team`} name={`team`}>
                <Select
                  disabled
                  style={{ width: "20%" }}
                  // placeholder="select team"
                  options={getTeam?.map((x: typeTeam, index: number) => ({ label: x.name, value: x.id, key: index }))}
                />
              </Form.Item>
            </Col>
            {data.status !== "DISABLED" ? (
              <Row gutter={[8, 8]} style={{ marginLeft: "100px", paddingLeft: "12px" }}>
                <Col>
                  <Button type="primary" htmlType="submit" onClick={() => form.setFieldsValue({ buttonSubmit: "DISABLED" })} danger>
                    {`Disable`}
                  </Button>
                </Col>
              </Row>
            ) : (
              <></>
            )}
          </Row>
        </Form>
      </Card>
    </Row>
  );
};
